import { CookieConsentService } from "./cookie-consent.js";
import { GoogleScriptsService, FacebookScriptsService } from "./tracking-scripts.js";
import Swiper, { Navigation, Zoom, Pagination, Thumbs } from 'swiper';
import { pushEnhancedEcommerce, pushAddToCart, pushProductView } from "./enhanced-ecommerce.js";
import Utils from "./utils";
import PriceHelper from "./price-helper";
import { ShoppingBasket_BindEvents } from './gak-ShoppingBasket'
import { SetDojj } from './gak-DeliveryOptions';
import { ShoppingBasket_UpdateItemCount } from './common';
import { initBasketPanelSwiper } from './shopping-basket-panel';
import { loadPayPalButton } from './gak-PayPalButton';
import { getFormattedPrice } from './price-formatter';

declare var ShoppingBasketParms: any;
declare var productDetailsParams: any;
declare var EuroPrice_CurrencySymbol: any;
declare var EuroPrice_ConversionRate: any;

window.onload = function () {
    ProductDetails_BindEvents();
    pushEnhancedEcommerce();
    pushProductView();
};

function showWaitElement(show: any) {
    var waitElem = document.getElementsByClassName("wait-spinner")!.item(0)!;
    if (waitElem) {
        if (show) waitElem.classList.remove('hidden');
        else waitElem.classList.add('hidden');
    }
}

function showItemAddedAlert() {
    var basketAlert = document.getElementById("basketAlert");
    var alertText = document.querySelector("#basketAlert p");

    if (basketAlert && alertText) {
        basketAlert.className = "[ alert ] [ bg-green-1 text-green text-15 text-md-16 ]";
        alertText.textContent = "1x item added to basket";
    }
}
function ProductDetails_BindEvents() {
    getDynamicData();

    var addToBasketButton = document.querySelectorAll(".add-to-basket-button");

    addToBasketButton.forEach(function (button) {
        button.addEventListener("click", function () {
            ProductDetail_AddProductToOrder(productDetailsParams.ProductID, productDetailsParams.Title, productDetailsParams.FbContentIDS, 1);
        });
        button.removeAttribute("disabled");
        button.removeAttribute("data-modal-disabled");
        button.classList.remove("btn-disabled");
    });

    bindAddToBasketFromPanel();

    //about finance link
    var financeLink = document.querySelector("a[href='#about-finance']");
    if (financeLink) {
        financeLink.addEventListener("click", function (evt) {
            evt.preventDefault();
            let financeTab = document.getElementById("financeTab");
            if (financeTab) {
                financeTab.click();
                let detailsSection = document.querySelector('.pdp-full-details ');
                if (detailsSection) {
                    detailsSection.scrollIntoView({ behavior: "smooth" });
                }
            }
        });
    }

    //description read more button
    let descriptionTabContents = document.getElementById("t1");
    if (descriptionTabContents) {
        if (descriptionTabContents.getBoundingClientRect().height > 550) {
            let toggleContents = document.querySelector("#t1 .toggle-parent .toggle-content");
            if (toggleContents) {
                toggleContents.classList.add('show-more-item');
            }
            let toggleButtons = document.querySelector("#t1 .toggle-parent .toggle-control");
            if (toggleButtons) {
                toggleButtons.classList.remove('hidden');
            }
            addToggleEvent();
        }
    }

    var ToggleButtons = document.querySelectorAll('[data-toggle-parent]');
    if (ToggleButtons.length) {
        ToggleButtons.forEach(function (toggle) {
            if (!toggle.classList.contains('click-bound')) {
                toggle.classList.add('click-bound');
                toggle.addEventListener('click', function (e) {
                    let elem = e.target as HTMLElement;
                    if (elem.getAttribute('aria-expanded') == "false") {
                        elem.setAttribute('aria-expanded', 'true')
                    }
                    else {
                        elem.setAttribute('aria-expanded', 'false');
                    }
                })
            }
        })
    }


    let buyNowWithPayPal = document.getElementById("buyNowWithPayPal");

    if (buyNowWithPayPal) {
        buyNowWithPayPal.addEventListener("click", function (e: any) {
            buyNowWithPayPal_do(false);
        });

        buyNowWithPayPal.classList.remove("btn-disabled");
    }

    const checkoutWithPayPalbtn = document.getElementById("paypal-button-container");

    if (checkoutWithPayPalbtn) {
        loadPayPalButton({
            clientId: ShoppingBasketParms.PaylPalClientId,
            currency: "GBP",
            components: "messages,buttons"
        }, "checkout", true);
    }

    const products = document.querySelectorAll(".list-view li");
    products.forEach(function (productItem) {
        productItem.addEventListener('mouseover', function () {
            productItem.classList.add('hover');
        });
        productItem.addEventListener('mouseout', function () {
            productItem.classList.remove('hover');
        });
    });

    function getDynamicData() {
        const requestHeaders: HeadersInit = new Headers();
        requestHeaders.set('Content-Type', 'application/json');

        var data = { productId: productDetailsParams.ProductID };

        fetch(`${productDetailsParams.GetBStockProductsURL}?productId=${data.productId}`, {
            method: 'GET'
        }).then(response => {
            if (response.ok) {
                return response.text();
            }
        }).then(function (data: any) {
            if (data && data.trim().length > 0) {
                var tabContainer = document.querySelector("[data-tab-name='bstock']");
                var bStockTab = document.getElementById("bStockTab");

                if (bStockTab && tabContainer) {
                    bStockTab.classList.remove("visually-hidden");
                    tabContainer.innerHTML = data;
                }
            }
        });

        if (!productDetailsParams.SkipGetDynamicData) {
            fetch(productDetailsParams.GetDynamicDataURL, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: requestHeaders
            }).then(response => response.json())
                .then(function (data: any) {
                    processDeliveryTimingDisplayData(data.timingDisplayData);
                    processStockStatusData(data.stockStatusData);
                });
        }

        function processDeliveryTimingDisplayData(data: any) {
            productDetailsParams.DeliveryNextDayPossible = data.nextDayDeliveryPossible;
            productDetailsParams.DeliveryCutOffDisplay = data.deliveryCutOffTimeDisplay;
            productDetailsParams.DeliveryCutOffms = data.deliveryCutOffMsSinceUnixEpoch;
        }
        function processStockStatusData(data: any) {
            if (!data.inStock) {
                let elem = document.getElementById('inStock');
                if (elem) document.getElementById('inStock')!.style.display = "none";
                loadNotifyMeDiv();
            }
            else {
                var msgHtml = data.msg2 || data.msg1 || (data.inStock ? "Next day delivery" + (data.isEligibleClickAndCollect ? " or Click & Collect" : "") : "Out of stock,<br />available to order");
                if (msgHtml === productDetailsParams.CollectionDeliveryMsg) msgHtml = "";
                let deliveryInfoMessage = data.msg2 || data.msg1 || (data.inStock ? "Next day delivery" + (data.isEligibleClickAndCollect ? " or Click & Collect" : "") : "Out of stock,<br />available to order");
                let deliveryInfoElems = document.querySelectorAll('.pdp-heading-reviews .delivery-info');
                deliveryInfoElems.forEach(function (element) {
                    (element as HTMLElement).style.display = "block";
                    element.innerHTML = deliveryInfoMessage;
                });

                var nowMs = (new Date).getUTCMilliseconds();

                if (productDetailsParams.DeliveryNextDayPossible && data.isNextDay && data.inStock && productDetailsParams.DeliveryCutOffms > nowMs)
                    setCountDown(productDetailsParams.DeliveryCutOffms);
            }

            if (data.isEligibleClickAndCollect) {
                let elem = document.getElementById('clickAndCollect');
                if (elem) document.getElementById('clickAndCollect')!.style.display = "flex";
            }

            let usps = document.getElementById('product-usps');
            if (usps) usps.style.opacity = "1";
        }


        function loadHtmlWithRecaptcha(htmlContent: string) {
            let parser = new DOMParser();
            const doc = parser.parseFromString(htmlContent, 'text/html');

            var recaptchaContainer = doc.getElementsByClassName('ajaxRecaptchaContainer');

            if (recaptchaContainer && recaptchaContainer.item(0))
                recaptchaContainer.item(0)!.getElementsByTagName('script')!.item(0)!.remove();

            var notifyMeWhenInStockDiv = document.getElementById("notifyMeWhenInStockDiv");

            if (notifyMeWhenInStockDiv)
                document.getElementById("notifyMeWhenInStockDiv")!.innerHTML = htmlContent;

            var recaptchaElem = document.getElementsByClassName('g-recaptcha')!;
            if (typeof grecaptcha !== 'undefined' && grecaptcha && grecaptcha.render && recaptchaElem.length > 0) {
                grecaptcha.render((<HTMLElement>recaptchaElem.item(0)));
            }
        }

        function onNotifyMeWhenInStock(e: any) {
            if (e.success) {
                let modal = document.getElementById('notifyMeWhenInStockModal');
                var msgClass = e.success ? 'text-success success' : 'text-danger';
                var newDiv = '<div class="' + msgClass + '">' + e.message + '</div>';
                let div = document.getElementById("notifyMeWhenInStockDiv");
                if (div) div.innerHTML = newDiv;
                let defaultContent = document.getElementById('notify-default');
                let defaultSuccess = document.getElementById('notify-success');
                if (defaultContent) defaultContent.classList.add("hidden");
                if (defaultSuccess) defaultSuccess.classList.remove("hidden");
            }
            else {
                let elem = document.getElementById('notifyMeWhenInStockModalErrorList')
                if (elem) elem.textContent = e.message;
                document.getElementById('notifyMeWhenInStockModalErrors')?.classList?.remove('hidden');
            }
        }

        // Notify Me When In Stock Div
        function loadNotifyMeDiv() {

            var recaptchaS = document.createElement("script");
            recaptchaS.setAttribute("src", "https://www.google.com/recaptcha/api.js");
            document.body.appendChild(recaptchaS);

            fetch(productDetailsParams.NotifyMeURL,
                {
                    method: 'GET',
                    cache: 'no-cache'
                }).then(response => response.text())
                .then(function (data) {
                    loadHtmlWithRecaptcha(data);
                    var modal = document.getElementById("notifyMeWhenInStockModal");

                    if (modal)
                        modal.setAttribute('data-modal', '');

                    var notifyMeBtn = document.getElementsByClassName('notifyMeWhenInStockBtn')!.item(0)!;

                    if (notifyMeBtn) {

                        notifyMeBtn.setAttribute('data-modal-open', 'notifyMeWhenInStockModal');

                        (window as any).ARIAmodal.init();

                        notifyMeBtn.addEventListener('click', function () {
                            let notifyModal = document.getElementById('notifyMeWhenInStockModal')!;

                            document.getElementById('notifyMeWhenInStockModalErrors')!.classList.add('hidden');

                            if (typeof grecaptcha !== 'undefined' && grecaptcha && grecaptcha.reset) {
                                grecaptcha.reset();
                            }

                            notifyModal.style.display = "block";
                        });
                    }
                    var btnSubmit = document.getElementById("btnSubmit")!;
                    if (btnSubmit) {
                        btnSubmit.addEventListener("click", function (e) {
                            var notifyForm = (<HTMLFormElement>document.querySelector('#notifyMeWhenInStockForm')!);
                            let data = new FormData(notifyForm);

                            fetch(productDetailsParams.NotifyMeURL, {
                                method: 'POST',
                                body: data
                            }).then(response => response.json())
                                .then(function (data) {
                                    onNotifyMeWhenInStock(data);
                                });
                        });
                    }
                });
        }
    }
}

function bindAddToBasketFromPanel() {
    var addToBasketFromPanel = document.querySelectorAll(".add-to-basket-from-panel-button");

    addToBasketFromPanel.forEach(function (button: any) {
        button.addEventListener("click", function () {
            const productCard = button.closest(".product-card");
            const productId = productCard.getAttribute("data-id");
            const title = productCard.getAttribute("data-name");
            ProductDetail_AddProductToOrder(productId, title, productDetailsParams.FbContentIDS, 1);
        });
    });

    var addCompanionToBasketFromPanel = document.querySelectorAll(".add-companion-to-basket-from-panel-button");

    addCompanionToBasketFromPanel.forEach(function (button: any) {
        button.addEventListener("click", function () {
            const companionCard = button.closest(".product-card");
            const companionProductId = companionCard.getAttribute("data-id");
            const primaryProductId = companionCard.getAttribute("data-primary-product-id");

            if (primaryProductId)
                ProductDetail_AddCompanaionToOrder(+primaryProductId, +companionProductId);
        });
    });
}

//function loadVideo(url) {
//    $('#videoIframe').prop('src', url);
//    $('#remoteVideoModal').modal('show');
//}

function ProductDetail_GoToShoppingBasket(facebookFeedId?: any, basketErrorId?: number) {
    if (facebookFeedId != null && facebookFeedId != "" && CookieConsentService.didConsentToAllCookies()) {
        // Facebook Track code
        // AddToCart
        // Track when items are added to a shopping cart (ex. click/landing page on Add to Cart button)

        FacebookScriptsService.addFacebookTracking(false);
        var fbq = FacebookScriptsService.getFbq();
        fbq('track', 'AddToCart', {
            content_type: 'product', // Required for Dynamic Product Ads
            content_ids: facebookFeedId // Required for Dynamic Product Ads
        });
        // End Facebook Track code
    }

    window.location.href = ShoppingBasketParms.GoToShoppingBasketURL;
}

// It will add the product and quantity to the basket, taking into account that the underlyingProduct must be created as an order item also.
function ProductDetail_AddFreeGift(theModalDialog: any, theSlickElement: any, theJqueryProduct: any, underlyingProductId: number, underlyingProductFacebookFeedId: any, maxItemsAllowed: number) {

    ShoppingBasketParms.FreeGiftList.push({
        productId: parseInt(theJqueryProduct.attr("myId")),
        //quantity: parseInt(theJqueryProduct.attr("myQuantity")),
        masterProductId: underlyingProductId,
        facebookFeedId: underlyingProductFacebookFeedId
    });

    //if (ShoppingBasketParms.FreeGiftList.length >= maxItemsAllowed) {
    //    // Proceed to add the FreeGifts To Order.
    //    //ProductDetail_AddFreeGiftsToOrder();
    //    theModalDialog.modal('toggle'); // Closing the modal makes the AddFreeGiftsToOrder being invoked.
    //}
    //else {
    //    // Remove the selected item
    //    // http://stackoverflow.com/questions/30739499/slick-js-how-to-remove-current-slide
    //    //theJqueryProduct.addClass("hidden");
    //    var i = theJqueryProduct.attr("data-slick-index");
    //    theSlickElement.slick('slickRemove', i);
    //    $("div.slick-slide").each(function () {
    //        var j = $(this).attr("data-slick-index");
    //        if (j > i) {
    //            $(this).attr("data-slick-index", j - 1);
    //        }
    //    });

    //}
}

export function ProductDetail_AddCompanaionToOrder(primaryProductId: number, companionId: number) {
    if (primaryProductId === null || companionId == null) return;

    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('Content-Type', 'application/json');

    var body = { primaryId: primaryProductId, companionId: companionId };

    fetch(ShoppingBasketParms.AddCompanionToOrderURL, {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify(body)
    }).then(response => response.json())
        .then(function (data: any) {
            if (data.success) {
                loadBasketPanel(function () {
                    pushAddToCart(primaryProductId, 1);
                });

                if (data.basketErrorId) {
                    var checkoutBtn = document.getElementById("checkout-btn");
                    var basketButton = document.getElementById("basketButton");
                    var errorUrl = `${ShoppingBasketParms.GoToShoppingBasketURL}?errorId=${data.basketErrorId}`;
                    if (checkoutBtn)
                        checkoutBtn.setAttribute("href", errorUrl);

                    if (basketButton)
                        basketButton.setAttribute("data-url", errorUrl);
                }

                showItemAddedAlert();
                ShoppingBasket_UpdateItemCount();
            }
        });
}

export function ProductDetail_AddProductToOrder(productId: number, productTitle: string, facebookFeedId: any, productQuantity: number, redirectToBasket?: any) {
    if (productId === null) return;
    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('Content-Type', 'application/json');

    var body = { productId: productId, quantity: productQuantity }

    var basketEmptyMessage = document.getElementById("basketEmptyMessage")!;
    var modalBasketContent = document.getElementById("modalBasketContent")!;
    var modalBasketTotals = document.getElementById("modalBasketTotals")!;

    modalBasketContent.removeAttribute("hidden");
    modalBasketTotals.removeAttribute("hidden");
    basketEmptyMessage.setAttribute("hidden", "hidden");

    fetch(ShoppingBasketParms.AddProductToOrderURL, {
        method: 'POST',
        headers: requestHeaders,
        body: JSON.stringify(body)
    }).then(response => response.json())
        .then(function (data: any) {
            if (data.success) {
                loadBasketPanel(function () {
                    pushAddToCart(productId, 1);
                });

                if (redirectToBasket) {
                    ProductDetail_GoToShoppingBasket(facebookFeedId, data.basketErrorId);
                }

                if (data.basketErrorId) {
                    let checkoutBtn = document.getElementById("checkout-btn");
                    let basketButton = document.getElementById("basketButton");
                    let errorUrl = `${ShoppingBasketParms.GoToShoppingBasketURL}?errorId=${data.basketErrorId}`;
                    if (checkoutBtn)
                        checkoutBtn.setAttribute("href", errorUrl);

                    if (basketButton)
                        basketButton.setAttribute("data-url", errorUrl);
                }

                showItemAddedAlert();
                ShoppingBasket_UpdateItemCount();
            }
        });
}
function waitForElm(selector: string) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
export function loadBasketPanel(callback?: any) {
    const body = { includeEarliestDeliveryDates: true }
    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('Content-Type', 'application/json');

    fetch(ShoppingBasketParms.GetBasketItemsURL, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: requestHeaders
    }).then(response => response.json())
        .then(function (data: any) {
            var ulElem = document.getElementsByClassName("order-process-basket")!.item(0)!;
            var totalElem = document.getElementById("basketTotal")!;
            var subTotalElem = document.getElementById("basketSubTotal")!;
            var deliveryPriceElem = document.getElementById("checkoutDeliveryPrice")!;
            var deliveryDescriptionElem = document.getElementById("checkoutDeliveryDescription")!;
            var deliveryMoreOptionsElem = document.getElementById("checkoutDeliveryMoreOptions")!;
            var basketEmptyMessage = document.getElementById("basketEmptyMessage")!;
            var modalBasketContent = document.getElementById("modalBasketContent")!;
            var modalBasketTotals = document.getElementById("modalBasketTotals")!;

            if (ulElem && data.basketVm.Items.length > 0) {
                modalBasketContent.removeAttribute("hidden");
                modalBasketTotals.removeAttribute("hidden");
                basketEmptyMessage.setAttribute("hidden", "hidden");

                var nonGVItems = data.basketVm.Items.filter(function (item: any) {
                    return !item.IsGiftVoucher
                });
                var liElem = "";
                var minDeliveryPrice = 0;

                if (nonGVItems.length == 0) {
                    deliveryPriceElem.textContent = getFormattedPrice(0, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate);
                } else {
                    SetDojj(data.deliveryOptions);
                    var defaultDeliveryOption = data.defaultDeliveryOption;
                    minDeliveryPrice = defaultDeliveryOption.DayPriceList[0].Price;
                    var formattedPrice = getFormattedPrice(minDeliveryPrice, EuroPrice_CurrencySymbol, EuroPrice_ConversionRate);

                    deliveryPriceElem.textContent = formattedPrice;
                    deliveryDescriptionElem.textContent = defaultDeliveryOption.Description;

                    if (defaultDeliveryOption.IsSuperSaverNationalRatioApplied) {
                        deliveryMoreOptionsElem.textContent = "For next day, special and international delivery go to checkout";
                    } else {
                        deliveryMoreOptionsElem.textContent = "For special and international delivery go to checkout";
                    }
                }
                data.basketVm.Items.forEach(function (item: any) {
                    liElem +=
                        `<li class="basket-item" data-name="${item.Title}" data-price="${item.Price}" data-quantity="${item.Quantity}" data-id="${item.ID}" data-product-id="${item.ProductID}">
                        <div class="basket-item--thumbnail">
                            <a href="${item.Url}">
                                <img src="${Utils.getImageURL(61, 77, item.ProductImageUrl)}" alt="${item.Title}">
                            </a>
                        </div>
                        <div class="basket-item--details">
                            <div class="item-title">
                                <a href="${item.Url}">
                                    ${item.Title}
                                </a>
                            </div>
                            <div class="basket-item--delete">
                                <button type="button" class="btn btn-link-sm remove-order-item-button"><span data-modal-x=""></span></button>
                            </div>
                            <div class="basket-price-qty">                                    
                                <div class="item-price">
                                    ${PriceHelper.formatPrice(item.Price)}
                                    ${setOldPrice(item)}
                                </div>
                                <div class="quantity-spinner">
                                    <select name='quantity' class='quantity-select' ${item.IsFreeGift ? 'disabled' : ''}>
                                        ${!item.IsFreeGift ? getQuantityOptions(item.Quantity) :
                            `<option value=${item.Quantity}>${item.Quantity}</option>`}
                                    </select>
                                </div>
                            </div>
                        </div>                        
                    </li>`
                });

                setQuickBuys(data);

                if (subTotalElem) {
                    subTotalElem.textContent = PriceHelper.formatPrice(data.basketVm.PriceTotalItems);
                }
                var total = data.basketVm.PriceTotalItems;

                if (minDeliveryPrice > 0)
                    total += minDeliveryPrice;

                if (totalElem) {
                    totalElem.textContent = PriceHelper.formatPrice(total);
                }

                ulElem.innerHTML = liElem;
                ShoppingBasket_BindEvents(true);
            }
            else {
                modalBasketContent.setAttribute("hidden", "hidden");
                modalBasketTotals.setAttribute("hidden", "hidden");
                basketEmptyMessage.removeAttribute("hidden");
                ulElem.innerHTML = "";

                var swiper = document.querySelector("#quickBuysSection .swiper-wrapper");

                if (swiper)
                    swiper.closest("section")!.setAttribute("hidden", "hidden");
            }

            ShoppingBasket_UpdateItemCount();


            //sometime basket panel loads and disappears leaving the mask on. check if this happened
            let basketpanel = document.getElementById('modalbasket');
            if (basketpanel && basketpanel?.getAttribute('hidden') != null) {
                let closeButton = document.querySelector('#modalbasket .a11y-modal__close-btn') as HTMLButtonElement;
                if (closeButton) closeButton.click();        
            }

            if (callback)
                callback();
        });

    const quantitySelectMax = 20

    function getQuantityOptions(quantity: number) {
        let options = "";

        for (var i = 1; i <= quantitySelectMax; i++) {
            options += `<option value=${i} ${i == quantity ? 'selected' : ''}>${i}</option>`
        }

        return options;
    }
}

function setOldPrice(item: any) {
    if (item.Price < item.RRP)
        return `<div class="old-price">${PriceHelper.formatPrice(item.RRP)}</div>`;

    return "";
}

function setQuickBuys(data: any) {
    var companions = data.basketCompanions;
    var accessories = data.basketVm?.CrossSellProducts;
    var inStockCompanions = companions?.filter(function (item: any) {
        return item.IsProductStockAvailable;
    });
    var inStockAccessories = accessories?.filter(function (item: any) {
        return item.Availability == 1; // In Stock
    });

    if (inStockCompanions && inStockCompanions.length > 0) {
        renderQuickBuys(inStockCompanions);
    } else if (inStockAccessories && inStockAccessories.length > 0) {
        renderQuickBuys(inStockAccessories);
    } else if (companions?.length > 0) {
        renderQuickBuys(companions)
    } else if (accessories?.length > 0) {
        renderQuickBuys(accessories)
    }
    else {
        var swiper = document.querySelector("#quickBuysSection .swiper-wrapper");

        if (swiper)
            swiper.closest("section")!.setAttribute("hidden", "hidden");
    }
}

function renderQuickBuys(items: any) {
    let swiperElem = "";
    let counter = 1;
    let swiper = document.querySelector("#quickBuysSection .swiper-wrapper");

    if (!swiper || !items) {
        return;
    }

    items.forEach(function (item: any) {
        swiperElem +=
            `<div class="swiper-slide">
                <div class="product-card" data-name="${item.Title}"
                        data-id="${item.Id ?? item.ID}"
                        data-price="${getItemPrice(item)}"
                        data-brand="${item.BrandDescription}"
                        data-category="${item.CategoryDescription}"
                        data-position="${counter}"
                        data-list="${getListName(item)}"
                        data-primary-product-id=${item.PrimaryProductID}>
                    <div>
                        <a href="${item.WebsiteUrl}" onclick="event.stopPropagation()">
                            <figure>
                                <picture>
                                    <source media="(max-width: 767px)" srcset="${Utils.getImageURL(310, 310, item.ProductImageUrl)}, ${Utils.getImageURL(620, 620, item.ProductImageUrl)} 2x" type="image/jpeg">
                                    <source media="(min-width: 768px)" srcset="${Utils.getImageURL(322, 390, item.ProductImageUrl)}, ${Utils.getImageURL(644, 980, item.ProductImageUrl)} 2x" type="image/jpeg">
                                    <img class="product--image object-fit contain" src="${Utils.getImageURL(550, 550, item.ProductImageUrl)}" alt="${item.Title}" title="${item.Title}" loading="lazy">
                                </picture>

                                <figcaption class="visually-hidden">${item.Title}</figcaption>
                            </figure>
                        </a>
                        <h3 class="[ description ] [ font-body ]">
                            <a href="${item.WebsiteUrl}" onclick="event.stopPropagation()" class="clamp">
                                ${item.Title}
                            </a>
                        </h3>
                    </div>
                    <div class="product-card--body">       
                         ${setSavings(item)}
                        <div class="price">
                            <div>
                                <strong>
                                    ${PriceHelper.formatPrice(getItemPrice(item))}
                                </strong>
                            </div>
                        </div>
                        <div class="add">
                            <button class="btn btn-secondary btn-sm ${getItemAddToBasketClass(item)}">Add</button>
                        </div>
                    </div>
                </div>
            </div>`;

        counter++;
    });

    swiper.innerHTML = `${swiperElem}<div class="swiper-slide dummy" aria-hidden="true">&nbsp;</div>`;
    swiper.closest("section")!.removeAttribute("hidden");
    initBasketPanelSwiper();
    bindAddToBasketFromPanel();

    function setSavings(item: any) {
        var itemPrice = getItemPrice(item);
        var itemRRPPrice = Math.max(item.RRP, item.Price);
        var savePrice = itemRRPPrice - itemPrice;

        if (item.IsCompanion && savePrice > 0)
            return `<div class="saving">Save ${PriceHelper.formatPrice(savePrice)}</div>`

        return "";
    }

    function getItemPrice(item: any) {
        return item.IsCompanion ? Math.min(item.CompanionPrice, item.Price) : item.Price;
    }

    function getItemAddToBasketClass(item: any) {
        return item.IsCompanion ? 'add-companion-to-basket-from-panel-button' : 'add-to-basket-from-panel-button';
    }

    function getListName(item: any) {
        return item.IsCompanion ? "Companions" : "Accessories";
    }
}

function setCountDown(date: any) {
    var countDownDate = new Date(date).getTime();
    // Update the count down every 1 second
    var x = setInterval(function () {

        var now = new Date().getTime();

        var distance = countDownDate - now;
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (distance < 0) {
            clearInterval(x);
            let elem1 = document.getElementById('inStock');
            if (elem1) document.getElementById('inStock')!.style.display = "none";

        } else {
            let elem2 = document.getElementById('coundDownContainer');
            if (elem2) document.getElementById('coundDownContainer')!.style.display = "flex";
            let countdownTime = document.getElementById("countdownTime")
            if (countdownTime)
                countdownTime.innerHTML = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        }
    }, 1000);
}

function checkoutWithPayPal() {
    const requestHeaders: HeadersInit = new Headers();

    let checkoutWithPayPal = document.getElementById("checkoutWithPayPal");
    let spinner = document.querySelector(".page-loading-spinner.darker");
    let addToBasketBtn = document.querySelector(".add-to-basket-button");
    let modalBasket = document.getElementById("modalbasket");

    if (modalBasket) {
        modalBasket.setAttribute("hidden", "hidden");
    }

    if (spinner) {
        spinner.classList.remove("hidden");
    }

    requestHeaders.set('Content-Type', 'application/json');
    fetch(ShoppingBasketParms.CheckoutWithPayPalURL,
        {
            method: 'POST',
            headers: requestHeaders
        }
    ).then(response => response.json())
        .then(function (data: any) {
            if (data.success) {
                window.location = data.redirectUrl;
            }
            else {
                alert(data.message);
            }
        }).finally(() => {
            //On a timeout as loading Paypal takes some time
            setTimeout(() => {
                if (checkoutWithPayPal) {
                    checkoutWithPayPal.classList.remove("btn-disabled");
                    checkoutWithPayPal.removeAttribute("disabled");

                    if (spinner) {
                        spinner.classList.add("hidden");
                    }
                }

                if (addToBasketBtn) {
                    addToBasketBtn.classList.remove("btn-disabled");
                    addToBasketBtn.removeAttribute("disabled");
                }
            }, 3500);
        });
}


function buyNowWithPayPal_do(isPayPalCredit: boolean) {
    buyNowWithPayment(productDetailsParams.ProductID, 1, isPayPalCredit);

    function buyNowWithPayment(productId: any, quantity: any, isPayPalCredit: boolean) {
        var qty = parseInt(quantity);
        if (isNaN(qty)) {
            alert("Please insert a valid quantity");
        } else {
            const requestHeaders: HeadersInit = new Headers();
            requestHeaders.set('Content-Type', 'application/json');

            var body = { productId: productId, quantity: qty, isPayPalCredit: isPayPalCredit }
            var addToBasketBtn = document.querySelector(".add-to-basket-button");

            if (addToBasketBtn) {
                addToBasketBtn.classList.add("btn-disabled");
                addToBasketBtn.setAttribute("disabled", "true");
            }
            var buyNowWithPayPal = document.getElementById("buyNowWithPayPal");
            var spinner = document.querySelector(".page-loading-spinner.darker");

            if (buyNowWithPayPal) {
                buyNowWithPayPal.classList.add("btn-disabled");
                buyNowWithPayPal.setAttribute("disabled", "true");

                if (spinner) {
                    spinner.classList.remove("hidden");
                }
            }

            fetch(ShoppingBasketParms.BuyNowWithPayPalURL,
                {
                    method: 'POST',
                    headers: requestHeaders,
                    body: JSON.stringify(body)
                }
            ).then(response => response.json())
                .then(function (data: any) {
                    if (data.success) {
                        window.location = data.redirectUrl;
                    }
                    else {
                        alert(data.message);
                    }
                }).finally(() => {
                    //On a timeout as loading Paypal takes some time
                    setTimeout(() => {
                        if (buyNowWithPayPal) {
                            buyNowWithPayPal.classList.remove("btn-disabled");
                            buyNowWithPayPal.removeAttribute("disabled");

                            if (spinner) {
                                spinner.classList.add("hidden");
                            }
                        }

                        if (addToBasketBtn) {
                            addToBasketBtn.classList.remove("btn-disabled");
                            addToBasketBtn.removeAttribute("disabled");
                        }
                    }, 3500);
                });
        }
    }
}

///////////////////////////////////////////////////////////////////
//                            Tabs                               //
///////////////////////////////////////////////////////////////////

const Tabby = require('tabbyjs');
if (document.getElementsByClassName('tabs').length) {
    const tabSelectors = document.querySelectorAll('[data-tabs]');

    tabSelectors.forEach((tabs, i) => {
        tabs.setAttribute(`data-tabs-${i}`, '');
        new Tabby(`[data-tabs-${i}]`);
    });



    /* The below code is used to scroll the tabs along when mobile users click,
    so they can see there are more tabs available. Safari doesn't yet support scroll-behaviour:smooth thouhg, but will soon */

    document.querySelectorAll('.tabs li').forEach((tabItem) => {
        tabItem.addEventListener('click', (elem) => {
            ((elem.currentTarget as HTMLElement).parentNode as HTMLElement).scrollLeft = (elem.currentTarget as HTMLElement).offsetLeft;
        });
    });
}

///////////////////////////////////////////////////////////////////
//                            Carousels                          //
///////////////////////////////////////////////////////////////////
function initNavigationSwipers(swiperName: string, nextButton: string, prevButton: string) {
    let newSwiper = new Swiper(swiperName, {
        modules: [Navigation],
        direction: 'horizontal',
        cssMode: true,
        slidesPerView: "auto",
        loop: false,
        speed: 600,
        navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
        },
        breakpoints: {
            1024: {
                cssMode: false,
                slidesPerView: 4,
                spaceBetween: 40,
            },
        },
    });
    return newSwiper;
}

if (document.querySelector(".thumbnail-gallery .swiper")) {
    var galleryThumbs = new Swiper(".thumbnail-gallery .swiper", {
        modules: [Navigation, Pagination],
        centeredSlides: true,
        centeredSlidesBounds: true,
        slidesPerView: "auto",
        direction: 'horizontal',
        navigation: {
            nextEl: '.thumbnail-gallery .swiper-button-next',
            prevEl: '.thumbnail-gallery .swiper-button-prev',
        },
        breakpoints: {
            900: {
                direction: 'vertical',
                slidesPerView: 5,
            },
        },
    });

    const gallerymain = new Swiper('.main-gallery .swiper', {
        modules: [Navigation, Zoom, Pagination, Thumbs],
        slidesPerView: "auto",
        zoom: true,
        loop: false,
        speed: 600,
        navigation: {
            nextEl: '.thumbnail-gallery .swiper-button-next',
            prevEl: '.thumbnail-gallery .swiper-button-prev',
        },
        thumbs: {
            swiper: galleryThumbs
        },
    });
    gallerymain.on('zoomChange', function () {
        var picture = document.querySelector('.main-gallery .swiper-slide.swiper-slide-active picture');
        var img = picture?.querySelector('img');
        var sourceAll = picture?.querySelectorAll('source');
        if (img && img.hasAttribute('data-zoomsrc') && sourceAll) {
            for (var i = 0, max = sourceAll.length; i < max; i++) {
                if (sourceAll) sourceAll[i]?.remove();
            }
            let zoomSrc = img?.getAttribute('data-zoomsrc')?.toString();
            if (zoomSrc) img?.setAttribute('src', zoomSrc);
        }
    });
}
if (document.querySelector(".swiper.recommended")) {
    const recommended = initNavigationSwipers('.swiper.recommended', '.recommended-container .swiper-button-next', '.recommended-container .swiper-button-prev');
    //const recommended = new Swiper('.swiper.recommended', {
    //    modules: [Navigation],
    //    direction: 'horizontal',
    //    cssMode: true,
    //    slidesPerView: "auto",
    //    loop: false,
    //    speed: 600,
    //    navigation: {
    //        nextEl: '.recommended-container .swiper-button-next',
    //        prevEl: '.recommended-container .swiper-button-prev',
    //    },
    //    breakpoints: {
    //        1024: {
    //            cssMode: false,
    //            slidesPerView: 4,
    //            spaceBetween: 40,
    //        },
    //    },
    //});
}
if (document.querySelector(".swiper.alsobought")) {
    const alsobought = initNavigationSwipers('.swiper.alsobought', '.alsobought-container .swiper-button-next', '.alsobought-container .swiper-button-prev');
    //const alsobought = new Swiper('.swiper.alsobought', {
    //    modules: [Navigation],
    //    direction: 'horizontal',
    //    cssMode: true,
    //    slidesPerView: "auto",
    //    loop: false,
    //    speed: 600,
    //    navigation: {
    //        nextEl: '.alsobought-container .swiper-button-next',
    //        prevEl: '.alsobought-container .swiper-button-prev',
    //    },
    //    breakpoints: {
    //        1024: {
    //            cssMode: false,
    //            slidesPerView: 4,
    //            spaceBetween: 40,
    //        },
    //    },
    //});
}
if (document.querySelector(".swiper.packagedeals")) {
    const packagedeals = initNavigationSwipers('.swiper.packagedeals', '.packagedeals-container .swiper-button-next', '.packagedeals-container .swiper-button-prev');
    //const alsobought = new Swiper('.swiper.packagedeals', {
    //    modules: [Navigation],
    //    direction: 'horizontal',
    //    cssMode: true,
    //    slidesPerView: "auto",
    //    loop: false,
    //    speed: 600,
    //    navigation: {
    //        nextEl: '.packagedeals-container .swiper-button-next',
    //        prevEl: '.packagedeals-container .swiper-button-prev',
    //    },
    //    breakpoints: {
    //        1024: {
    //            cssMode: false,
    //            slidesPerView: 4,
    //            spaceBetween: 40,
    //        },
    //    },
    //});
}
if (document.querySelector(".swiper.accessories")) {
    const accessories = initNavigationSwipers('.swiper.accessories', '.accessories-container .swiper-button-next', '.accessories-container .swiper-button-prev');
    //const alsobought = new Swiper('.swiper.accessories', {
    //    modules: [Navigation],
    //    direction: 'horizontal',
    //    cssMode: true,
    //    slidesPerView: "auto",
    //    loop: false,
    //    speed: 600,
    //    navigation: {
    //        nextEl: '.accessories-container .swiper-button-next',
    //        prevEl: '.accessories-container .swiper-button-prev',
    //    },
    //    breakpoints: {
    //        1024: {
    //            cssMode: false,
    //            slidesPerView: 4,
    //            spaceBetween: 40,
    //        },
    //    },
    //});
}
if (document.querySelector(".swiper.upgrade")) {
    const upgrade = initNavigationSwipers('.swiper.upgrade', '.upgrade-container .swiper-button-next', '.upgrade-container .swiper-button-prev');
    //const alsobought = new Swiper('.swiper.upgrade', {
    //    modules: [Navigation],
    //    direction: 'horizontal',
    //    cssMode: true,
    //    slidesPerView: "auto",
    //    loop: false,
    //    speed: 600,
    //    navigation: {
    //        nextEl: '.upgrade-container .swiper-button-next',
    //        prevEl: '.upgrade-container .swiper-button-prev',
    //    },
    //    breakpoints: {
    //        1024: {
    //            cssMode: false,
    //            slidesPerView: 4,
    //            spaceBetween: 40,
    //        },
    //    },
    //});
}
///////////////////////////////////////////////////////////////////
//                        Toggle function (Show more)            //
///////////////////////////////////////////////////////////////////
addToggleEvent();

function addToggleEvent() {
    if (document.getElementsByClassName('toggle-parent').length) {
        // Show more boxes
        var showMoreToggles = document.querySelectorAll('.toggle-control .btn');
        showMoreToggles.forEach(function (toggle) {
            if (!toggle.classList.contains('event-added')) {
                toggle.classList.add('event-added');
                toggle.addEventListener('click', function (e) {
                    let elem = e.target as HTMLElement;
                    if (!(e.target as HTMLElement).outerHTML.startsWith('<button') && elem.parentElement) {
                        elem = elem.parentElement;
                    }
                    if (elem) {
                        var msg = elem.firstChild as HTMLElement;
                        var closeddmsg = elem.getAttribute('data-closedmsg');
                        var toggledmsg = elem.getAttribute('data-toggledmsg');
                        var item = elem.parentElement?.parentElement?.querySelector('.toggle-content');
                        if (item && msg && item.classList.contains('show')) {
                            item.classList.remove('show');
                            if (closeddmsg) msg.innerHTML = closeddmsg;
                            elem.setAttribute('aria-expanded', 'false')
                        }
                        else if (item && msg) {
                            item.classList.add('show');
                            if (toggledmsg) msg.innerHTML = toggledmsg;
                            elem.setAttribute('aria-expanded', 'true');
                        }
                    }
                })
            }
        })
    }
}

///////////////////////////////////////////////////////////////////
//           Toggle stickiness of "Add to Basket" button         //
///////////////////////////////////////////////////////////////////

window.onscroll = function (e) {
    var windowWidth = window.innerWidth;
    if (windowWidth < 1024) {
        var documentBody = document.body;
        var isSticky = false;

        var basketButton = document.querySelector('.add-to-basket-static');
        var basketButtonPos = basketButton!.getBoundingClientRect();

        var footerLinks = document.querySelector('.footer-links');
        var footerPosition = footerLinks!.getBoundingClientRect();

        if ((basketButtonPos.top >= 0 && basketButtonPos.bottom <= window.innerHeight && !isSticky) ||
            (footerPosition.top >= 0 && footerPosition.bottom <= window.innerHeight && !isSticky)) {
            documentBody.classList.remove('sticky-buy-now');
            isSticky = false
        } else {
            documentBody.classList.add('sticky-buy-now');
            isSticky = true;
        }
    }
}
